module.exports = __webpack_public_path__ + "static/img/2661_phase_function_Paper_PointsHejduk_Prediction.61f8069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2661_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nt0p
// module chunks = 0